import { createAsyncThunk } from '@reduxjs/toolkit'
import { handleExport } from '../../../../../../helpers/export'
import FinancialAnalysisService from '../../../core/service'

export const getBankEarningsQualityThunk = createAsyncThunk(
  'financialAnalysis/Bank/getBankEarningsQuality',
  async (data, { rejectWithValue }) => {
    const response = await FinancialAnalysisService.getEarningsQuality(data)
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const downloadBankEarningsQuality = createAsyncThunk(
  'financialAnalysis/Bank/downloadBankEarningsQuality',
  async (data) => {
    const response = await FinancialAnalysisService.downloadEarningsQuality(
      data,
    )
    handleExport(response.data, response.filename)
  },
)
